<template>
  <div class="news-wrapper">
    <img class="circle" src="/static/img/home/news/circle.svg" alt="">
    <div class="news-latest">
      <h2 class="desktop">Latest<br>Alcomet<br>News</h2>
      <h2 class="mobile">Latest Alcomet News</h2>
      <router-link class="all-btn desktop" to="/news"><span class="alcomet">r</span> All Alcomet News</router-link>
    </div>
    <div class="news-container">
      <router-link v-for="currentNews in news" :to="`/news/${currentNews.url}`" :key="currentNews.url" class="news-main" :style="{backgroundImage: `url(/uploads/news/${currentNews.cover})`}">
          <div class="news-footer">
              <span>{{currentNews.date | formatDate}}</span>
              <h6>{{currentNews.content.en.title}}</h6>
          </div>
      </router-link>
    </div>
    <router-link class="all-btn mobile" to="/news"><span class="alcomet">r</span> All Alcomet News</router-link>
  </div>
</template>

<script>
export default {
  data() {
    return {
      news: []
    };
  },
  methods: {
    getLatestNews() {
      this.news = [];
      this.$http
        .get(`${process.env.ROOT_API}/news/latest`)
        .then(response => {
          response.data.news.forEach(item => {
            this.news.push(item);
          });
        })
        .catch(error => {
          // handle error
          console.log(error);
        })
        .then(() => {
          // always executed
        });
    }
  },
  mounted() {
    this.getLatestNews();
  }
};
</script>

<style scoped>
.news-wrapper {
  display: flex;
  justify-content: center;
  padding: 0 40px 20px;
  position: relative;
}
.circle {
  height: 110vh;
  left: -55vh;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 110vh;
  z-index: 1;
}
h1 {
  color: #004787;
  font-size: 36px;
  font-weight: 300;
  margin: 50px 0;
}
.news-latest {
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: space-between;
  padding: 50px 0;
  position: relative;
  width: 15%;
  z-index: 2;
}
.news-container {
  display: flex;
  height: 485px;
  position: relative;
  width: 85%;
  z-index: 2;
}
.news-main {
  background-color: #fff;
  background-size: cover;
  background-position: 50% 50%;
  border-radius: 5px;
  -webkit-box-shadow: 0px 17px 41px 0px rgba(51, 58, 69, 0.36);
  -moz-box-shadow: 0px 17px 41px 0px rgba(51, 58, 69, 0.36);
  box-shadow: 0px 17px 41px 0px rgba(51, 58, 69, 0.36);
  cursor: pointer;
  height: 100%;
  margin-left: 5%;
  position: relative;
  -webkit-transition: all 0.6s cubic-bezier(0.075, 0.82, 0.165, 1);
  -moz-transition: all 0.6s cubic-bezier(0.075, 0.82, 0.165, 1);
  -ms-transition: all 0.6s cubic-bezier(0.075, 0.82, 0.165, 1);
  -o-transition: all 0.6s cubic-bezier(0.075, 0.82, 0.165, 1);
  transition: all 0.6s cubic-bezier(0.075, 0.82, 0.165, 1);
  width: 28.33%;
}
.news-main::before {
  align-items: center;
  border-radius: 50%;
  background-color: rgba(44, 125, 206, 0.89);
  -webkit-box-shadow: 0px 8px 17px 0px rgba(44, 125, 206, 0.32);
  -moz-box-shadow: 0px 8px 17px 0px rgba(44, 125, 206, 0.32);
  box-shadow: 0px 8px 17px 0px rgba(44, 125, 206, 0.32);
  color: #fff;
  content: "c";
  font-family: "alcomet";
  font-size: 22px;
  display: flex;
  height: 60px;
  justify-content: center;
  left: -30px;
  position: absolute;
  top: 8%;
  width: 60px;
}
.news-main:hover {
  transform: translateY(-5px);
}
.news-img {
  border-radius: 6px;
  -o-object-fit: cover;
  object-fit: cover;
  height: 100%;
  width: 100%;
}
.news-footer {
  background: -moz-linear-gradient(
    top,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 1) 100%
  );
  background: -webkit-linear-gradient(
    top,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 1) 100%
  );
  background: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 1) 100%
  );
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#00000000', endColorstr='#000000',GradientType=0 );
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
  bottom: 0;
  padding: 25px;
  position: absolute;
  width: 100%;
}
.news-footer span {
  color: #fff;
  border-radius: 20px;
  display: inline-block;
  font-size: 12px;
  margin-bottom: 10px;
}
.news-footer h6 {
  color: #fff;
  font-size: 18px;
}
.all-btn {
  align-items: center;
  border: 1px solid #588cc1;
  border-radius: 30px;
  display: inline-flex;
  font-size: 14px;
  font-weight: 700;
  height: 35px;
  justify-content: center;
  line-height: initial;
  margin: 30px 0 0;
  overflow: hidden;
  padding: 8px 20px 8px 10px;
  position: relative;
  -webkit-transition: all 0.2s ease;
  -moz-transition: all 0.2s ease;
  -ms-transition: all 0.2s ease;
  -o-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.all-btn span {
  margin-right: 10px;
}
.all-btn:hover {
  background-color: #dde7ee;
}
.mobile {
  display: none;
}
@media screen and (max-width: 1600px) {
  .news-container {
    height: 450px;
  }
}
@media screen and (max-width: 1440px) {
  .news-container {
    height: 400px;
  }
  .news-footer h6 {
    font-size: 18px;
  }
}
@media screen and (max-width: 1366px) {
  .news-container {
    height: 300px;
  }
}
@media screen and (max-width: 1280px) {
  .news-latest h2 {
    font-size: 20px;
    line-height: 22px;
  }
  .all-btn {
    font-size: 12px;
  }
}
@media screen and (max-width: 1000px) {
  .desktop {
    display: none;
  }
  .mobile {
    display: flex;
  }
  .news-wrapper {
    align-items: center;
    flex-direction: column;
    overflow: hidden;
    padding-bottom: 0;
  }
  .news-wrapper h2 {
    font-size: 20px;
  }
  .all-btn {
    margin: 15px 0 0;
    position: relative;
    z-index: 2;
  }
  .news-latest {
    padding: 30px 0;
    flex-direction: row;
    width: 100%;
  }
  .news-container {
    flex-direction: column;
    height: 100vw;
    /* margin: 0;
    width: 100%; */
  }
  .news-main {
    background-position: top;
    margin: 10px 0;
    width: 100%;
  }
}
@media screen and (max-width: 600px) {
  .news-container {
    height: 150vw;
    margin: 0;
    width: 100%;
  }
  .news-main::before {
    font-size: 22px;
    height: 40px;
    left: -20px;
    width: 40px;
  }
  .news-footer {
    padding: 15px;
  }
  .news-footer span {
    font-size: 10px;
    margin-bottom: 0;
  }
  .news-footer h6 {
    font-size: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home/News.vue